var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1435_34964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.375 17.001H29.75C30.0318 17.001 30.302 17.1129 30.5013 17.3122C30.7006 17.5114 30.8125 17.7817 30.8125 18.0635V26.5635C30.8125 26.8453 30.7006 27.1155 30.5013 27.3148C30.302 27.514 30.0318 27.626 29.75 27.626H4.25C3.96821 27.626 3.69796 27.514 3.4987 27.3148C3.29944 27.1155 3.1875 26.8453 3.1875 26.5635V18.0635C3.1875 17.7817 3.29944 17.5114 3.4987 17.3122C3.69796 17.1129 3.96821 17.001 4.25 17.001H10.625",
    stroke: "#4E83E4",
    strokeWidth: 1.99989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 17.0012V3.18872",
    stroke: "#4E83E4",
    strokeWidth: 1.99989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.625 9.56372L17 3.18872L23.375 9.56372",
    stroke: "#4E83E4",
    strokeWidth: 1.99989,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9692 23.9061C25.8496 23.9061 26.5634 23.1924 26.5634 22.312C26.5634 21.4315 25.8496 20.7178 24.9692 20.7178C24.0887 20.7178 23.375 21.4315 23.375 22.312C23.375 23.1924 24.0887 23.9061 24.9692 23.9061Z",
    fill: "#4E83E4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1435_34964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.e1acd8c7ca36290c9d64ef4d0aa582be.svg";
export { ForwardRef as ReactComponent };